/*
 * Cart drawer "Other Products For Your {vehicle}" (snippets/seatfit-cart-other-products.liquid). Liquid prints a card
 * for each other product on sale, but a car cover or floor mat price depends on the vehicle and that data only loads
 * with the SeatFit core. Loaded right after the core by snippets/seatfit-config.liquid, this script writes each
 * cover/mat card's "From" price for the cart's vehicle (rules: seatfit-other-products-prices.js) and hides any card
 * whose product has no fit for that car, as the buy-box block does. Without the core it does nothing, so a card keeps
 * no price rather than a wrong one. The drawer is re-rendered after every cart change and inserted scripts do not
 * run again, so a MutationObserver fills each new copy.
 */
(function () {
  'use strict';
  if (window.SeatFitCartOtherProducts) return;
  var KINDS = ['seat', 'cover', 'mat'];

  function ready() {
    return !!(window.SeatFit && window.SeatFit.resolve && window.SeatFit.tiersFor && window.SeatFitOtherProducts);
  }

  function hideIfEmpty(box) {
    if (!box.querySelector('[data-sf-cart-op-card]:not([hidden])')) box.hidden = true;
  }

  function fill(box) {
    if (!ready() || box.getAttribute('data-sf-filled')) return;
    box.setAttribute('data-sf-filled', '1');
    var SF = window.SeatFit;
    var P = window.SeatFitOtherProducts;
    var q = { year: box.getAttribute('data-year'), make: box.getAttribute('data-make'), model: box.getAttribute('data-model') };
    var fmt = box.getAttribute('data-money-format') || '';
    box.querySelectorAll('[data-sf-cart-op-card]').forEach(function (card) {
      var kind = card.getAttribute('data-kind');
      if (KINDS.indexOf(kind) < 0) return;
      SF.resolve(q, kind).then(function (ctx) {
        // Only a clear "this car is not in that product's data" hides the card; a failed download leaves it as is.
        if (ctx && ctx.status === 'unsupported') {
          card.hidden = true;
          hideIfEmpty(box);
          return;
        }
        if (kind === 'seat' || !P.fits(ctx)) return;
        var p = P.fromPriceOf(ctx);
        var el = card.querySelector('[data-sf-cart-op-price]');
        if (!el || !p || typeof p.price !== 'number') return;
        el.textContent = 'From ' + P.money(p.price, fmt);
        el.hidden = false;
      }).catch(function (e) { console.warn('[SeatFit] cart cross-sell', e); });
    });
  }

  function scan() {
    if (!ready()) return;
    document.querySelectorAll('[data-sf-cart-op]').forEach(fill);
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }

  try {
    new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('seatfit:ready', queue);
    window.addEventListener('load', queue);
    queue();
  } catch (e) {
    console.warn('[SeatFit] cart cross-sell init', e);
  }
  window.SeatFitCartOtherProducts = { scan: scan };
})();
